const Tag = ({ color, label }) => {
    color = color ? color : {
        bg: 'bg-gray-100',
        text: 'text-gray-800'
    };
    const style = `${color.bg} ${color.text}`;

    return (
        <span
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[0.65rem] font-medium ${style}`}
        >
            {label}
        </span>
    );
}

export default Tag